import React from "react";
import classes from "./styles.module.scss";
import { getHoverStyles } from "../../shared/colorUtils";

const PrimaryButton = ({
    disabled,
    float,
    onClick,
    type,
    buttonText,
    width,
    height,
    backgroundColor = "#007bff",
    color = "#fff",
    padding,
    marginTop,
    margin,
    fontSize,
    border,
    icon,
    icon_two,
    fontWight,
    iconRight
}) => {
    const { hoverBackground, hoverColor } = getHoverStyles(color, backgroundColor);
    const btnId = `btn-${Math.random().toString(36).substr(2, 9)}`;

    return (
        <>
            {/* {!disabled && (
                <style>{`
                    #${btnId}:hover {
                        background-color: ${hoverBackground} !important;
                        color: ${hoverColor} !important;
                        border: 1px solid ${hoverColor} !important;
                    }
                `}</style>
            )} */}
            <button
                id={btnId}
                onClick={onClick}
                className={classes.button}
                type={type}
                disabled={disabled}
                style={{
                    float,
                    width,
                    height,
                    backgroundColor,
                    color,
                    marginTop,
                    margin,
                    fontSize,
                    border,
                    padding,
                    fontWeight: fontWight,
                    cursor: disabled ? "not-allowed" : "pointer",
                }}
            >
                {icon}
                {icon_two}
                {buttonText}
                {iconRight}
            </button>
        </>
    );
};

export default PrimaryButton;
